import { useDispatch } from 'react-redux';

/**
 * staff関連のactionをdispatchするためのカスタムフック。
 *
 * @returns {object}
 * @returns {function} handleRoleSelect - 新しい権限をセットするためのハンドラー関数。
 * @returns {function} handleStatusSelect - 新しいアカウント状態をセットするためのハンドラー関数。
 * @returns {function} handleRemoteSupportStatusSelect - 新しい遠隔支援状態をセットするためのハンドラー関数。
 */
const useStaffActions = () => {
  const dispatch = useDispatch();
  const handleRoleSelect = newRole => {
    dispatch({ type: 'UPDATE_ROLE_SELECT', role: newRole });
  };

  const handleStatusSelect = newStatus => {
    dispatch({ type: 'UPDATE_ACCOUNT_STATUS_SELECT', status: newStatus });
  };

  const handleRemoteSupportStatusSelect = newStatus => {
    dispatch({
      type: 'UPDATE_REMOTE_SUPPORT_STATUS_SELECT',
      status: newStatus,
    });
  };

  return {
    handleRoleSelect,
    handleStatusSelect,
    handleRemoteSupportStatusSelect,
  };
};

export default useStaffActions;
